export default __webpack_public_path__ + "static/media/iam_logo.bd4968a8.svg";